import { Match, Schema, SchemaGetter } from 'effect';

export const Boolean = Schema.Boolean.annotate({
  message: 'Očekává se instance typu „boolean“.',
});

export const BooleanTrue = Boolean.check(
  Schema.makeFilter((b: boolean) => b, {
    message: 'Toto pole musí být zaškrtnuto',
  })
);

export const IsEqualToTrue = Schema.Literal(true).annotate({
  message: 'Hodnota musí být „true“',
});

export const BooleanFromString = Schema.Literals(['on', 'off', 'true', 'false', '1', '0']).pipe(
  Schema.decodeTo(Boolean, {
    decode: SchemaGetter.transform((literal) =>
      Match.value(literal).pipe(
        Match.when(Match.is('on', 'true', '1'), () => true),
        Match.when(Match.is('off', 'false', '0'), () => false),
        Match.exhaustive
      )
    ),
    encode: SchemaGetter.transform((bool) => (bool ? 'on' : 'off')),
  })
);
